import {Directive, HostBinding, HostListener} from '@angular/core';

@Directive({
  selector: '[appDeleteFocus]',
  standalone: true
})
export class DeleteFocusDirective {
  @HostBinding('class.selected') isFocused = false;

  @HostListener('focus') onFocus() {
    this.isFocused = true;
  }

  @HostListener('blur') onBlur() {
    this.isFocused = false;
  }
}
